import "../../styles/components/ScheduleConfirm.css";
import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import ConfirmShift from '../../components/icons/ConfirmShift'
import BButton from "../../components/general/BButton";
import moment from "moment";
import helper from "../../utils/helper";
import { useSearchParams } from "react-router-dom";
const ScheduleConfirm = ({ currentDate, checkList = [], onOK }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const queryhospitalName = searchParams.get('hospitalName')
  const querywardName = searchParams.get('wardName')
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    onOK()
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const toStartToEnd = (list = []) => {
    const _filter = list.filter(item => item.value == true)
    console.log('_filter >>', _filter)
    
    if (_filter) {
      let txt = []
      for (const f of _filter) {
        txt.push(`${helper.FN.toTimeHM(f.dataSelect?.shiftTimeFrom)} - ${helper.FN.toTimeHM(f.dataSelect?.shiftTimeTo)} น.`)
      }
      return txt.join(',')
    }
    return '-'
  };
  const toCheckList = (arr = []) => {
    return arr.filter(item => item.selected === false && item.value === true)
  }
  return (
    <>
      {/* {JSON.stringify(toCheckList(checkList))} */}
      <BButton setStyle="block" onClick={showModal} disable={toCheckList(checkList).length === 0} >ยืนยันการจอง</BButton>
      <Modal
        wrapClassName="modal-confirm-shift"
        open={isModalOpen}
        closable={false}
        onOk={handleOk} 
        onCancel={handleCancel}
        maskClosable={false}
        footer={[]}
      >
        <div className="confirm-shift">
            <div className="icon"><ConfirmShift/></div>
            <h4>คุณแน่ใจหรือไม่</h4>
            <div className="info-confirm">คุณต้องการจองการทำงาน</div>
            <div className="info-confirm"> วันที่ {currentDate} เวลา {toStartToEnd(checkList)}</div>
            <div className="info-shift">{queryhospitalName} : {querywardName}</div>
        </div>
        <div className="footer-confirm-shift">
          <BButton setStyle="outline confirm" onClick={handleCancel}>ยกเลิก</BButton>
          <BButton setStyle="confirm" onClick={handleOk}>ยืนยัน</BButton>
        </div>
      </Modal>
    </>
  );
};
export default ScheduleConfirm;